import styled from 'styled-components'
import { Paragraph } from './Paragraph'

const TranslatedParagraph = styled(Paragraph)`
  font-family: 'Quicksand';
  font-weight: 200;
`
export { TranslatedParagraph }
